<div class="container d-flex flex-column">
  <h1 class="title-center my-2">Default Config Placeholders</h1>
  <div>
    <button matButton="elevated" class="my-2" style="float: right" (click)="goToAddPage()">Add Default Config</button>
  </div>
  <div class="content">
    <app-lt-png-table #defaultConfigGrid [gridSettingsInput]="defaultConfigGridSettings()" [showToolbarInput]="false" (selectionChange)="selectionChangeHandler($event)"></app-lt-png-table>
  </div>

  <div>
    <button matButton="elevated" class="my-2" *ngIf="!showFullMapping" (click)="initShowFullMapping()">See Full Mapping All Together</button>
    <button matButton="elevated" class="my-2" *ngIf="showFullMapping" (click)="initHideFullMapping()">Hide Full Mapping</button>
  </div>
  <ng-container *ngIf="showFullMapping">
    <app-monaco-editor #monaco
                      (textChange)="monacoData = $event"
                      [editorData]="monacoData"
                      [lang]="'xml'"
                      [editAccess]="checkAccess(['LOSTalker.Admin'])"></app-monaco-editor>
  </ng-container>
</div>
